/**
 * Wizard Constants
 * 
 * Centralized constants for the import wizard.
 */

// Timing constants
export const SEARCH_DEBOUNCE_MS = 800; // Increased from 300ms to reduce server load
export const BLUR_DELAY_MS = 200;
export const MAX_SEARCH_RESULTS = 50;
export const MIN_SEARCH_CHARS = 3; // Minimum characters required before searching

// CSS class names
export const CSS_CLASSES = {
  // Dropdown
  DROPDOWN_MENU: 'dropdown-menu',
  DROPDOWN_ITEM: 'dropdown-item',
  DROPDOWN_ICON: 'dropdown-icon',
  DROPDOWN_INPUT: 'dropdown-input',
  DROPDOWN_INPUT_WRAPPER: 'dropdown-input-wrapper',
  DROPDOWN_ITEM_EMPTY: 'empty',
  DROPDOWN_ITEM_SELECTED: 'selected',
  
  // Contact search
  CONTACT_SEARCH_CONTAINER: 'contact-search-container',
  CONTACT_SEARCH_INPUT: 'contact-search-input',
  CONTACT_SEARCH_DROPDOWN: 'contact-search-dropdown',
  CONTACT_SEARCH_ITEM: 'contact-search-item',
  
  // Notify
  NOTIFY_DROPDOWN: 'notify-dropdown',
  NOTIFY_INPUT: 'notify-input',
  NOTIFY_USER_ITEM: 'notify-user-item',
  
  // General
  CHECKMARK: 'checkmark',
  SEARCH_ICON: 'search-icon'
};

// Icons
export const ICONS = {
  SEARCH: '🔍',
  DROPDOWN_OPEN: '▲',
  DROPDOWN_CLOSED: '▼',
  CHECKMARK: '✓',
  REMOVE: '×'
};

